import { createContext, useState, ReactNode, useCallback } from 'react'

interface TimerContextType {
    isRunning: boolean
    stopTimer: () => void
}

export const TimerContext = createContext<TimerContextType | undefined>(
    undefined,
)

export const TimerProvider = ({ children }: { children: ReactNode }) => {
    const [isRunning, setIsRunning] = useState(true)

    const stopTimer = useCallback(() => {
        setIsRunning(false)
    }, [])

    return (
        <TimerContext.Provider value={{ isRunning, stopTimer }}>
            {children}
        </TimerContext.Provider>
    )
}
